<template>
    <!--    服务信息 -->
    <div class="service-information">
        <OrderCaption title="服务信息" :capIcon="capIcon" />
        <div class="information-container">
            <Chunk title="订单编号">
                <template v-slot:context>
                    {{infos.numbering}}
                    <Button @click="copyInfo(infos.numbering)" class="chunk_copy" type="primary" size="mini">复制</Button>
                </template>
            </Chunk>

            <Chunk wid56 title="联系人" :desc="infos.contacts"></Chunk>

            <Chunk title="订单金额">
                <template v-slot:context>
                    <span class="chunk_money" v-if="infos.money || infos.money == 0">¥{{infos.money}}</span>
                </template>
            </Chunk>

            <Chunk title="服务地点" :desc="infos.address"></Chunk>

            <Chunk v-if="infos.skillsLabel" title="服务所需技能标签" :desc="infos.skillsLabel" limit></Chunk>

            <div class="infos-tip">*如需取消订单，请联系客服</div>

        </div>
    </div>
</template>
<script>
    import {Icon, Button, Toast} from 'vant';
    import OrderCaption from '@/components/OrderCaption/OrderCaption.vue'
    import Chunk from '@/components/Chunk/Chunk.vue'
    import BubbleTip from '@/components/BubbleTip/BubbleTip.vue'
    import { goCopy } from '@/utils/JSBridge.js'
    import findIcon from './img/icon_1.png';
    import studioIcon from './img/icon_2.png';

    export default {
        props: {
            componentType: {
                type: Number,
                default: 0
            },
            infos: {
                type: Object,
                default: () => ({
                    numbering: '', // 订单编号
                    contacts: '', // 联系人
                    contactInformation: '', // 联系方式
                    money: '', // 订单金额
                })
            }
        },
        computed: {
            capIcon() {
                return this.componentType == 1 ? studioIcon : findIcon;
            }
        },
        methods: {
            copyInfo(val) {
                goCopy(val);
                Toast('复制成功');
            }
        },
        components: {Icon, Button, OrderCaption, Chunk, BubbleTip}
    }
</script>
<style lang="scss" scoped>
    .service-information {
        .information-title {
            display: flex;
            align-items: center;
            padding: 20px 16px;
            font-size: 17px;
            font-weight: 400;
            color: rgba(34, 34, 34, 1);

            .title_icon {
                width: 16px;
                margin-right: 10px;
            }
        }

        .information-container {
            padding: 0 16px;

            .wid56 {
                width: 56px;
            }

            .chunk_copy {
                display: inline-block;
                width:45px;
                height:20px;
                line-height: 20px;
                text-align: center;
                background:rgba(243,245,249,1);
                border-radius:10px;
                align-items: center;
                justify-content: center;
                font-size:12px;
                font-weight:400;
                color:rgba(55,61,82,1);
                border: none;
            }
            .chunk_money {
                font-size: 16px;
                font-weight: 400;
                color: rgba(250, 87, 65, 1);
            }

            .infos-tip {
                font-size: 16px;
                font-weight: 400;
                color: rgba(34, 34, 34, 1);
                padding-top: 15px;
                padding-bottom: 25px;

            }
        }
    }
</style>
